import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row } from 'antd';
import { size, cloneDeep } from 'lodash';
import ReactMarkdown from 'react-markdown';

import {
  StyledButton,
  PopupBody,
  StyledCol,
  MarkdownDiv
} from 'components/Styled';
import PureModal from 'business/components/pureModal/index';

const Popup = props => {
  const { t } = useTranslation();

  const [display, setDisplay] = useState(false);
  const [popups, setPopups] = useState([]);

  useEffect(() => {
    setDisplay(true);
    setPopups([
      { id: 'spacer' },
      ...(props.popups || [])
    ]);
  }, [props.popups]);

  const handleClick = () => {
    const temp = cloneDeep(popups)
    temp.shift();
    setPopups([...temp]);
    if (size(temp) === 1) setDisplay(false);
  };

  return (
    <PureModal
      visible={display}
      closeable={false}
      maskClosable={false}
      maskStyle={{ zIndex: 1052 }}
      bodyStyle={{ width: 400, height: 'auto' }}
    >
      {popups.map((r, i) =>
        r.id === 'spacer' ? (
          <div key={r.id}></div>
        ) : (
          <PopupBody
            key={r.id}
            className={`popup-body ${props.type}`}
            style={{
              zIndex: size(popups) - i,
              maxWidth: props.maxWidth ? `${props.maxWidth}px` : undefined
            }}>
            {props.type === 'post' ? (
              <div>
                <Row>
                  <StyledCol
                    isPopup
                    style={{
                      backgroundImage: `url(${r.featureImage[t('key')]})`
                    }}></StyledCol>
                  <StyledCol isPopup>
                    <div>
                      <MarkdownDiv>
                        <div className="body-div">
                          <div>
                            <div>
                              <p className="title">{r.title[t('key')]}</p>
                              <ReactMarkdown source={r.content[t('key')]} />
                            </div>
                          </div>
                        </div>
                        <div className="button-div">
                          <StyledButton
                            onClick={handleClick}
                            type="primary"
                            shadow="true">
                            {t('common.ok')}
                          </StyledButton>
                        </div>
                      </MarkdownDiv>
                    </div>
                  </StyledCol>
                </Row>
              </div>
            ) : props.type === 'reschedule' ? (
              <div>
                {r.content}
                <div className="button-div">
                  {props.isRescheduled ? (
                    <div style={{ padding: '10px 20px 20px' }}>
                      <StyledButton
                        onClick={handleClick}
                        type="primary"
                        shadow="true">
                        {t('button.back')}
                      </StyledButton>
                    </div>
                  ) : (
                    <>
                      <div style={{ padding: '10px 20px 10px' }}>
                        <StyledButton
                          onClick={props.toReschedule}
                          type="primary"
                          shadow="true">
                          {t('button.start-revise')}
                        </StyledButton>
                      </div>
                      <div style={{ padding: '0 20px 20px' }}>
                        <StyledButton
                          ghost
                          type="primary"
                          onClick={handleClick}>
                          {t('button.cancel')}
                        </StyledButton>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ) : (
              <div>
                {r.content}
                <div style={{ padding: '20px' }}>
                  <StyledButton
                    onClick={handleClick}
                    type="primary"
                    shadow="true">
                    {i === size(popups) - 1
                      ? t('common.ok')
                      : t('common.next')}
                  </StyledButton>
                </div>
              </div>
            )}
          </PopupBody>
        )
      )}
    </PureModal>
  );
};

export default Popup;
